export const gitCommit = '8f70e237'
